import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default function CrewMap({ checkins = [] }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (!elRef.current) return;
    if (!mapRef.current) {
      mapRef.current = L.map(elRef.current, { scrollWheelZoom: false, attributionControl: false }).setView([20, 0], 2);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    if (layerRef.current) { map.removeLayer(layerRef.current); layerRef.current = null; }
    const group = L.featureGroup();
    checkins.forEach((c) => {
      if (c.lat == null || c.lng == null) return;
      const m = L.circleMarker([c.lat, c.lng], { radius: 8, color: "#D36B46", fillColor: "#D36B46", fillOpacity: 0.85, weight: 2 });
      m.bindPopup(`<b>${c.crew_name || "Crew"}</b><br/>${c.task_title || "On-site check-in"}<br/>${new Date(c.created_at).toLocaleString()}`);
      group.addLayer(m);
    });
    group.addTo(map);
    layerRef.current = group;
    const b = group.getBounds();
    if (b.isValid()) map.fitBounds(b.pad(0.3), { maxZoom: 15 });
    setTimeout(() => map.invalidateSize(), 120);
  }, [checkins]);

  useEffect(() => () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } }, []);

  return <div ref={elRef} data-testid="crew-map" style={{ height: "320px" }} className="w-full rounded-lg overflow-hidden border border-[var(--line)] z-0" />;
}
